import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { orderMailLogApi } from "../api/mailLog";

const mailLogKey = (orderId: string) => ["order-mail-log", orderId];

export function useOrderMailLog(orderId: string | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: mailLogKey(orderId ?? ""),
    queryFn: () => orderMailLogApi.list(orderId as string),
    enabled: !!orderId && enabled,
  });
}

export function useRetryOrderMail(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (logId: string) => orderMailLogApi.retry(orderId, logId),
    onSuccess: () => qc.invalidateQueries({ queryKey: mailLogKey(orderId) }),
  });
}

export function useSendOrderMail(orderId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => orderMailLogApi.send(orderId),
    onSuccess: () => qc.invalidateQueries({ queryKey: mailLogKey(orderId) }),
  });
}
